<template>
    <div class='container editor' v-loading = 'loading'>
        <!-- <div class='title'>
            <span>下发通知</span>
        </div> -->
        <div class='section editor'>
            <!--  -->
            <div class='address_type'>
                <div>
                    <span  class='must'>收件人:</span>
                </div>
                <div class='area'>
                    <div class='radio_area'>
                        <el-radio v-model="targetType" label="7">妇保院</el-radio>
                        <el-radio v-model="targetType" label="6">幼儿园</el-radio>
                    </div>
                    <div class='checkbox_area item'>
                        <el-checkbox v-model="isSecletedAll" v-if='targetType == 7 && !streetDisabled'>快速选择直辖妇保院</el-checkbox>
                    </div>
                    <div class='selector_area item'>
                        <el-select v-model="provinceId" v-if='!provinceDisabled' class='selector' :disabled='provinceDisabled'  @change='doChange("provinceId","cityOptions",1)' placeholder="请选择">
                            <el-option
                                v-for="item in provinceOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="cityId" v-if='!cityDisabled' class='selector' :disabled='cityDisabled' @change='doChange("cityId","districtOptions",2)' placeholder="请选择">
                            <el-option
                                v-for="item in cityOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-model="districtId" v-if='!districtDisabled' class='selector' :disabled='districtDisabled' @change='getDataList(3)' placeholder="请选择">
                            <el-option
                                v-for="item in districtOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class='transfer_area item'>
                         <el-transfer filterable ref='transfer'
                         v-model="choosenList" v-if='!streetDisabled || targetType == 6' :data="itemList" :titles='["筛选列表","待发送列表"]'></el-transfer>
                    </div>
                </div>
            </div>
            <!-- 接收角色 -->
            <div class='address_role' v-if='targetType == 6'>
                <div>
                    <span>接收角色:</span>
                </div>
                <div class='area'>
                    <div class='checkbox_area'>
                        <!-- <el-checkbox v-if='targetType == 6' v-model="adminK">超级管理员</el-checkbox> -->
                        <el-checkbox v-if='targetType == 6' v-model="master">园长</el-checkbox>
                        <el-checkbox v-if='targetType == 6' v-model="teacher">保健老师</el-checkbox>
                    </div>
                </div>
            </div>
             <!-- 接收角色 -->
            <div   class='address_title'>
                <div>
                    <span class='must'>消息主题:</span>
                    <el-input style='width:400px;margin-left:20px;' maxlength="50" v-model='themeTitle' ></el-input>
                </div>  
            </div>   
            <div   class='address_content'>
                <div>
                    <span class='must'>消息内容:</span>
                </div>  
                <div class='area'>   
                    <vue-html5-editor :content="htmlContent" :height="200" style='border-radius: 0px;'  @change="getHtml"></vue-html5-editor>
                    <div class='upload'>
                       <el-upload 
                       ref='upload'
                       :limit='9'
                        :action='imgurl()'
                        :headers="myHeaders" 
                        list-type="picture-card"
                        accept=".jpg,.bmp,.gif,.png"
                        :on-success="imgSuccess"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus" ></i>
                      </el-upload>
                      <el-dialog :visible.sync="mainVisible" :close-on-click-modal='false' append-to-body> 
                        <img width="100%" :src="mainImageUrl" alt="">
                      </el-dialog>
                    </div>
                </div>
            </div>  
            <div class='address_btnarea'>
                <div >
                    <el-button style='background:#409EFF;color:#fff' @click='doSend'>发送</el-button>   
                    <el-button @click='goBack'>取消</el-button>   
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
import ajax from '@/com/ajax'
import config from '@/com/config'
import editor from '@/components/utils/vue-editor'
import upload from '@/components/utils/uploadImg'

export default {
  data() {
    return {
      targetType: '7',
      isSecletedAll: false,
      orgId: '', // 当前妇保院ID
      provinceId: '',
      provinceOptions: [],
      provinceDisabled: false,
      cityId: '',
      cityOptions: [],
      cityDisabled: false,
      districtId: '',
      districtOptions: [],
      districtDisabled: false,
      streetName: '',
      streetDisabled: false, // 街道妇保院
      itemList: [],
      choosenList: [],
      themeTitle: '', // 发送主题
      htmlContent: '',
      accessoryList: [],
      loading: false,
      level: 1, // 妇保院级别
      adminK: true,
      teacher: true,
      master: true,
      disUp: 0, // 附件数量
      myHeaders: { 'Haiziguo-Token': localStorage.getItem('Haiziguo-Token') },
      dialogImageUrl: [],
      mainVisible: false,
      mainImageUrl: ''
    }
  },
  components: {
    editor,
    upload
  },
  props: {
    show: {
      type: Boolean
    }
  },
  watch: {
    targetType(val) {
      this.getOptions('', 'provinceOptions', true)
      this.getCurrentLevel()
      this.choosenList = []
      this.itemList = []
      this.cityId = ''
      this.provinceId = ''
      this.districtId = ''

      this.$refs.transfer.clearQuery('left')
      this.$refs.transfer.clearQuery('right')
    },
    districtId(val) {
      if (val !== '') {
        // this.getDataList()
      }
    },
    isSecletedAll(val) {
      if (val) {
        let self = this
        this.cityId = ''
        this.provinceId = ''
        this.districtId = ''
        this.getCurrentLevel()
        self.choosenList = []
        this.getQuickInfo(function(tempList) {
          for (let i in tempList) {
            self.choosenList.push(tempList[i].key)
          }
        })
      } else {
        this.choosenList = []
      }
    },
    show(val) {
      if (val) {
        this.initData()
        // 初始化，获取全部数据
        this.getOptions('', 'provinceOptions', true)
        // 获取妇保院级别
        this.getCurrentLevel()
        this.$refs.upload.clearFiles()
        this.$refs.transfer.clearQuery('left')
        this.$refs.transfer.clearQuery('right')
      }
    }
  },
  methods: {
    initData() {
      let data = {
        targetType: '7',
        isSecletedAll: false,
        orgId: '', // 当前妇保院ID
        provinceId: '',
        provinceOptions: [],
        provinceDisabled: false,
        cityId: '',
        cityOptions: [],
        cityDisabled: false,
        districtId: '',
        districtOptions: [],
        districtDisabled: false,
        streetName: '',
        streetDisabled: false, // 街道妇保院
        itemList: [],
        choosenList: [],
        themeTitle: '', // 发送主题
        htmlContent: '',
        accessoryList: [],
        loading: false,
        level: 1, // 妇保院级别
        adminK: true,
        teacher: true,
        master: true,
        disUp: 0, // 附件数量
        myHeaders: { 'Haiziguo-Token': localStorage.getItem('Haiziguo-Token') },
        dialogImageUrl: [],
        mainVisible: false,
        mainImageUrl: ''
      }
      for (let key in data) {
        this[key] = data[key]
      }
    },
    doSend() {
      // 0、校验
      if (this.choosenList.length === 0) {
        this.$message.error('请选择收件人')
        return
      }
      let temp = this.themeTitle.split(' ').join('')
      if (temp.length === 0) {
        this.$message.error('请输入消息主题')
        return
      }
      temp = this.htmlContent.split('&nbsp;').join('')
      temp = temp.split(' ').join('')
      if (temp.length === 0) {
        this.$message.error('请输入消息内容')
        return
      }

      // 1、转换收件人的属性格式
      this.loading = true
      this.htmlContent = this.htmlContent.replace(
        /<a href="/g,
        '<a target="view_window" href="'
      )

      let receiverList = []
      for (let i in this.choosenList) {
        let key = this.choosenList[i]
        for (let j in this.itemList) {
          if (this.itemList[j].key === key) {
            let receiverID = this.itemList[j].key
            let receiverName = this.itemList[j].label
            let receiverType = this.targetType
            receiverList.push({
              receiverID: receiverID,
              receiverName: receiverName,
              receiverType: receiverType
            })
          }
        }
      }
      let roleList = []
      if (this.targetType === 7) {
        roleList.push('超级管理员')
      } else {
        // if (this.adminK) {
        //   roleList.push('超级管理员')
        // }
        if (this.master) {
          roleList.push('超级管理员')
          roleList.push('园长')
        }
        if (this.teacher) {
          roleList.push('保健老师')
        }
      }
      let param = {
        title: this.themeTitle,
        contents: this.htmlContent,
        receiverList: receiverList,
        accessoryList: this.accessoryList,
        subType: this.targetType,
        roleList: roleList
      }
      let self = this
      ajax
        .post(config.khsHost + 'infoflow/message/hhs/send', param)
        .then(function(res) {
          if (res && res.success) {
            //self.$router.replace('/outbox')
            self.$emit('close')
          }
          self.loading = false
        })
    },
    doChange(parentLabel, targetOption, level) {
      this.getDataList(level)
      this.getOptions(parentLabel, targetOption)
    },
    imgSuccess(res, file, fileList) {
      // 图片上传成功之后
      if (res.success === true) {
        file.url = res.body
        var photo = []
        fileList.forEach(function(i) {
          var obj = {}
          // obj.pType = '1'
          obj.accessoryAddress = i.url
          obj.accessoryName = i.name
          photo.push(obj)
        })
        this.accessoryList = photo
      } else {
        this.$message.error('上传图片失败')
        return false
      }
      if (fileList.length === 9) {
        this.disUp = true
      } else {
        this.disUp = false
      }
    },
    handlePictureCardPreview(file) {
      // 查看大图
      this.mainImageUrl = file.url
      this.mainVisible = true
    },
    // 主图
    handleRemove(file, fileList) {
      // 移除
      var photo = []
      fileList.forEach(function(i) {
        var obj = {}
        obj.accessoryAddress = i.url
        obj.accessoryName = i.name
        photo.push(obj)
      })
      this.accessoryList = photo
      if (fileList.length > 9) {
        this.disUp = true
      } else {
        this.disUp = false
      }
    },
    getHtml(payload) {
      this.htmlContent = payload
    },
    filterInfo() {},
    getOptions(parentType, options, isInit, callback) {
      // 0、判断是否初始化，获取省份信息
      this.loading = true
      let parentID = 0
      if (isInit) {
        parentID = 0
      } else {
        // 1、更改后原数据清空
        switch (parentType) {
          case 'provinceId':
            this.cityId = ''
            break
          case 'cityId':
            this.districtId = ''
            break
        }
        parentID = this[parentType]
        // 判断parentID是否是全部，全部的话则将现有的属性清空
        if (parentID === '') {
          this[options] = []
          return
        }
      }
      let self = this
      // 2、 获取数据
      ajax
        .post(config.host + 'common/getAreasList.do', { parentID: parentID })
        .then(function(res) {
          if (res && res.success) {
            let list = res.body.list
            list.unshift({ id: '', name: '全部' })
            for (let i in list) {
              let obj = {}
              obj.value = list[i].id
              obj.label = list[i].name
              self.$set(self[options], i, obj)
            }
            if (callback !== undefined) {
              callback()
            }
          }
          self.loading = false
        })
    },
    getUrl(payload) {
      if (this.accessoryList.length === 0) {
        this.accessoryList.push({
          accessoryName: '',
          accessoryAddress: payload
        })
      } else {
        this.accessoryList[0].accessoryAddress = payload
      }
    },
    getDataList(type) {
      this.loading = true
      let targetType = this.targetType
      let apiUrl = ''
      switch (targetType) {
        case '7':
          apiUrl = config.host + '/org/getHhsOrgListByAreaID.do'
          break
        case '6':
          apiUrl = config.khsHost + 'support/forHhs/org/getOrgListByAreaID.do'
          break
      }
      let nparm = {
        // 'cityID': this.cityId,
        // 'countryID': this.districtId,
        // 'provinceID': this.provinceId
      }
      switch (type) {
        case 1:
          nparm.provinceID = this.provinceId
          break
        case 2:
          nparm.cityID = this.cityId
          nparm.provinceID = this.provinceId
          break
        case 3:
          nparm.cityID = this.cityId
          nparm.countryID = this.districtId
          nparm.provinceID = this.provinceId
          break
        case 4:
          nparm.cityID = this.cityId
          nparm.countryID = this.districtId
          nparm.provinceID = this.provinceId
          break
      }
      let self = this

      ajax.post(apiUrl, nparm).then(function(res) {
        if (res && res.success) {
          let list = res.body.list
          let tempList = []
          for (let i in list) {
            let obj = {}
            obj.key = list[i].orgID
            obj.label = list[i].fullName
            if (obj.key !== self.orgID) {
              self.$set(tempList, i, obj)
            }
          }
          self.itemList = tempList
          // if (self.isSecletedAll) {
          //   for (let i in self.itemList) {
          //     self.choosenList.push(self.itemList[i].key)
          //   }
          // }
        }
        self.loading = false
      })
    },
    getQuickInfo(callback) {
      let self = this
      self.loading = true

      ajax
        .post(config.host + 'org/getHhsOrgListDirect.do', {})
        .then(function(res) {
          if (res && res.success) {
            let list = res.body.list
            let tempList = []
            for (let i in list) {
              let obj = {}
              obj.key = list[i].orgID
              obj.label = list[i].fullName
              self.$set(tempList, i, obj)
            }
            // self.itemList = tempList

            if (callback !== undefined) {
              callback(tempList)
            }
          }
          self.loading = false
        })
    },
    getCurrentLevel() {
      let self = this
      self.loading = true
      ajax.get(config.host + 'org/getOrgDetail.do').then(function(res) {
        if (res && res.success) {
          let type = res.body.scopeType
          let list = res.body
          self.level = type
          switch (type) {
            case 1:
              // 1、省级妇保院
              self.provinceId = list.provinceID
              self.provinceDisabled = true
              self.orgID = list.orgID
              self.getDataList(type)
              self.getOptions('provinceId', 'cityOptions', false)
              break
            case 2:
              // 2、市级妇保院
              self.provinceId = list.provinceID
              self.provinceDisabled = true
              self.orgID = list.orgID
              self.getOptions('provinceId', 'cityOptions', false, function() {
                self.cityId = list.cityID
                self.cityDisabled = true
                self.getDataList(type)
                self.getOptions('cityId', 'districtOptions', false)
              })
              break
            case 3:
              // 3、区级妇保院
              self.provinceId = list.provinceID
              self.provinceDisabled = true
              self.orgID = list.orgID
              self.getOptions('provinceId', 'cityOptions', false, function() {
                self.cityId = list.cityID
                self.cityDisabled = true
                self.getOptions('cityId', 'districtOptions', false, function() {
                  self.districtId = list.countryID
                  self.districtDisabled = true
                  self.getDataList(type)
                })
              })
              break
            case 4:
              // 街道妇保院
              self.provinceId = list.provinceID
              self.provinceDisabled = true
              self.cityId = list.cityID
              self.cityDisabled = true
              self.districtId = list.countryID
              self.districtDisabled = true
              self.streetName = list.street
              self.streetDisabled = true
              self.getDataList(type)
              break
          }
          self.loading = false
        }
      })
    },
    goBack() {
      //this.$router.go(-1)
      this.$emit('close')
    },
    imgurl() {
      // 上传插件地址
      return config.khsHost + 'order/notice/uploadFile.do'
    }
  },
  created() {
    // 初始化，获取全部数据
    this.getOptions('', 'provinceOptions', true)
    // 获取妇保院级别
    this.getCurrentLevel()
    // this.getQuickInfo()
  }
}
</script>

<style>
.el-radio__input.is-checked .el-radio__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
</style>

<style scoped>
.container.editor {
  width: 100%;
  min-height: 900px;
  background-color: #ffffff;
  display: block;
  padding: 0px;
}
.title {
  padding-top: 20px;
  padding-left: 20px;
  width: 100%;
  height: 70px;
  font-size: 20px;
  color: #cccccc;
}
.section {
  padding-top: 20px;
  padding-left: 20px;
}
.address_type {
  display: flex;
}
.area {
  padding-left: 30px;
}
.address_type .checkbox_area {
  margin-top: 10px;
}
.address_type .selector_area {
  margin-top: 10px;
}
.address_type .item {
  margin-top: 10px;
}
.selector {
  width: 160px;
}
.address_role {
  display: flex;
  margin-top: 20px;
}
.address_content {
  margin-top: 20px;
  display: flex;
}
.address_title {
  margin-top: 10px;
}
.address_content .area {
  width: 600px;
  margin-left: -5px;
}
.address_btnarea {
  border-top: 1px solid #ddd;
  margin-left: -15px;
  padding-left: 15px;
  margin-top: 50px;
  padding-top: 15px;
}
.area .upload {
  min-height: 120px;
  padding-left: 10px;
  border: 1px solid #ddd;
  padding-top: 10px;
  padding-bottom: 10px;
}
.notShow {
  display: none;
}
.must::before {
  content: '*';
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/editor.vue?6ea5c0ea